import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addRoutineDietApi, listOfDietTypesApi, listOfRoutineDietApi, updateRoutineDietApi } from "../../../../../config/Api";
import { FilterApiData } from "../../../../../services/FilterApiData";

export const RoutineDiet = () => {
    const { Option } = Select;
    const [form] = Form.useForm();

    const [dietTypes, setDietTypes] = useState('')

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [routineDietData, setRoutineDietData] = useState()
    const [editRoutineDietRecord, setEditRoutineDietRecord] = useState()
    const [dietTypesList, setDietTypesList] = useState([]);
    const [loading, setLoading] = useState(false)

    // get the list of all available diet items with its diet type
    //==============================
    const getListOfRoutineDiet = () => {
        setLoading(true)

        listOfRoutineDietApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // get the list of all Diet Types
    //==============================
    const getListOfDietTypes = () => {
        setLoading(true)

        listOfDietTypesApi()
            .then((res) => {
                if (res.status === 200) {
                    setDietTypesList(FilterApiData(res.data.data));
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }
    // call when user click on edit
    //==============================
    const editRoutineDiet = (data) => {
        // console.log("d", data);
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name })
        form.setFieldsValue({ 'types': data.diet_type_id })
        setEditRoutineDietRecord(data);
    }

    useEffect(() => {
        getListOfRoutineDiet()
        getListOfDietTypes()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterRoutineDiet(routineDietData);
    }, [routineDietData]);

    // filter routine Diet
    //==============================
    const filterRoutineDiet = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            // console.log("dataSource", dataSource, data);
            dataSource.length > 0 && dataSource.forEach((element) => {
                // console.log(element.name);
                if (element?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element?.diet_type?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of Routine Diet
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateRoutineDietApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "RoutineDiet Update successfully",
                    });
                    getListOfRoutineDiet()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Diet Type',
            dataIndex: 'diet_type',
            key: 'diet_type',
            render: (text, data) => <a>{data?.diet_type?.name}</a>,
            // filters: [
            //     { text: "Cereals", value:  },
            //     { text: "Protiens", value:  },
            //     { text: "Beverages", value:  },
            //     { text: "Vegetables", value:  },
            //     { text: "Fruits", value:  },
            //     { text: "Snacks", value:  },
            //     { text: "Nuts", value:  },
            // ],
            // onFilter: (value, record) => record.dietType == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editRoutineDiet(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'idli Rice',
            dietType: 'Cereals',
            status: true
        },
        {
            id: '2',
            name: 'Toor Dal',
            dietType: 'Protiens',
            status: false
        },
        {
            id: '3',
            name: 'Coffee',
            dietType: 'Beverages',
            status: true
        },
        {
            id: '4',
            name: 'Cabbage',
            dietType: 'Vegetables',
            status: true
        },
        {
            id: '5',
            name: 'Apple',
            dietType: 'Fruits',
            status: true
        },
    ];

    // handle submit
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "diet_type_id": values.types,
                "status": true
            }
            addRoutineDietApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        form.setFieldsValue({ 'types': '' })
                        notification.success({
                            message: "RoutineDiet added successfully",
                        });
                        getListOfRoutineDiet()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "diet_type_id": values.types,
                "status": values.status
            }
            updateRoutineDietApi(editRoutineDietRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "RoutineDiet Update successfully",
                        });
                        getListOfRoutineDiet()
                        form.setFieldsValue({ 'name': '' })
                        form.setFieldsValue({ 'types': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="RoutineDiet">
            <Row>
                <Col xl={14}>
                    <Form
                        name="AddRoutineDietForm"
                        className="AddRoutineDietForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row>
                            <Col xl={8}>
                                <Form.Item
                                    name="types"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Type!",
                                        },
                                    ]}
                                    initialValue=""
                                >
                                    <Select
                                        // value={regType}
                                        onChange={(e) => setDietTypes(e)}
                                    >
                                        <Option value="" disabled hidden>
                                            Select Diet Types
                                        </Option>
                                        {
                                            dietTypesList && dietTypesList.length > 0 && dietTypesList.map((option, index) =>
                                                <Option value={option.id}>{option.name}</Option>
                                            )
                                        }
                                        {/* <Option value="Cereals">Cereals</Option>
                                        <Option value="Protiens">Protiens</Option>
                                        <Option value="Beverages">Beverages</Option>
                                        <Option value="Vegetables">Vegetables</Option>
                                        <Option value="Fruits">Fruits</Option>
                                        <Option value="Snacks">Snacks</Option>
                                        <Option value="Nuts">Nuts</Option> */}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter details!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter details" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={7}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}>
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    {/* <h6>{tagCategory ?  `Total ${tagCategory}` : "Total Tags"  }</h6> */}
                    <h6> Total : {displayData.length > 0 ? displayData.length : 0}   </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Diet Types"
                        onChange={(e) => { filterRoutineDiet(e.target.value); setRoutineDietData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>

            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
